import { makeStyles } from "@material-ui/core/styles"

const mobileAppBarStyles = makeStyles((theme) => ({
  menuButtomMobile: {
    paddingRight: theme.spacing(2),
    color: theme.palette.secondary.main,
  },
}))

export default mobileAppBarStyles
